// One environment policy for content carriers and the public manual reader.
export function shareEnvironment(userAgent = navigator.userAgent) {
  const wechat = /MicroMessenger/i.test(userAgent)
  const mobile = /Android|iPhone|SymbianOS|Windows Phone|iPod|iPad|Mobile/i.test(userAgent)
  return { wechat, mobile, preferMiniProgram: wechat && mobile }
}

export function miniDestination(response, qr) {
  const data = response && response.data && response.data.data
  const value = qr ? data && data.xacode : data && data.data && data.data.url_link
  if (typeof value !== 'string' || !/^https:\/\//.test(value)) throw new Error('missing_mini_destination')
  return value
}

export function inMiniProgram() {
  if (window.__wxjs_environment === 'miniprogram') return Promise.resolve(true)
  const api = window.wx && window.wx.miniProgram
  if (!shareEnvironment().wechat || !api || !api.getEnv) return Promise.resolve(false)
  return new Promise(resolve => {
    const timer = setTimeout(() => resolve(false), 500)
    api.getEnv(result => { clearTimeout(timer); resolve(!!result.miniprogram) })
  })
}
